<template>
  <button class="btn">
    <ListIcon class="btn__icon" />
    <p>{{ props.text }}</p>
  </button>
</template>

<script setup>
  import { Props } from './props';
  //-----------------------------
  import ListIcon from '../../svg/ListIcon.vue';
  //-----------------------------
  const props = defineProps(Props());
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>